export default __webpack_public_path__ + "static/site-59becb7135ddb91826e01d3849d45584.png";